import React from 'react';
import PropTypes from 'prop-types';
import { Link as ScrollLink } from 'react-scroll';
import env from '../../../config/env';

const Section = (props) => {
  const bgImage = `url(${env.url}${props.collection.image.path})`;
  return (
    <section id={props.sectionId} className={`bottom spotlight ${props.sectionStyle}`} style={{ backgroundPosition: 'center center', backgroundImage: bgImage }}>
      <span className="image fit main"><img src={`${env.url}${props.collection.image.path}`} alt="" /></span>
      <div className="content">
        <div className="container">
          <div className="row">
            <div className="w40">
              <header>
                <h2>{props.collection.title}</h2>
                <p>{props.collection.subtitle}</p>
              </header>
            </div>
            <div className="w60 multi-column" dangerouslySetInnerHTML={{ __html: props.collection.content }}></div>
          </div>
        </div>
      </div>
      <ScrollLink activeClass="active" className="goto-next scrolly" to={props.next} spy={true} smooth={true} offset={0}
        duration={500}>
        Next
      </ScrollLink>
    </section>
  );
};

export default Section;

Section.propTypes = {
  sectionId: PropTypes.string,
  sectionStyle: PropTypes.string,
  href: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/wrapper/section/Section.js